import { getRegistrationState } from './registration.selectors';
import { createSelector } from "@ngrx/store";
import { IRegistrationState } from "../../state/registration.state";
import { Dictionary } from '@ngrx/entity';
import { IBankDetail } from 'src/app/models/registration/bankDetails';
import { IBankDetailsState } from '../../state/bank-details.state';

export const getBankDetailsState = createSelector(
    getRegistrationState,
    (state: IRegistrationState) => state.banks
);

export const selectBankDetails = createSelector(
    getBankDetailsState,
    (state: IBankDetailsState) => state.details
);
